import { createContext, useMemo, type ReactNode } from "react";
import type { Permission } from "@/lib/permissions";
import { getPermissions } from "@/lib/permissions";
import { useAuth } from "@/hooks/useAuth";

interface PermissionContextValue {
  permissions: Permission[];
  hasPermission: (permission: Permission) => boolean;
}

export const PermissionContext = createContext<PermissionContextValue | undefined>(undefined);

export function PermissionProvider({ children }: { children: ReactNode }) {
  const { usuario } = useAuth();
  const permissions = useMemo(() => getPermissions(usuario?.perfil?.nome), [usuario?.perfil?.nome]);
  const value = useMemo(
    () => ({ permissions, hasPermission: (permission: Permission) => permissions.includes(permission) }),
    [permissions],
  );

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
